const busyQueues = {}
const queues = {}

const dequeue = async (queueName) => {
  if (!!busyQueues[queueName]) return

  const newPrint = queues[queueName].shift()

  if (!newPrint) return

  const { job, reject, resolve } = newPrint

  try {
    busyQueues[queueName] = true

    await job()

    resolve()

    busyQueues[queueName] = false

    dequeue(queueName)
  } catch (err) {
    reject(err)

    busyQueues[queueName] = false

    dequeue(queueName)
  }
}

const enqueuePrint = (queueName, job) => (
  new Promise((resolve, reject) => {
    if (!!queues[queueName]) {
      queues[queueName].push({
        resolve,
        reject,
        job
      })
    } else {
      queues[queueName] = [{
        job,
        resolve,
        reject
      }]
    }

    Object.keys(queues).forEach(qName => dequeue(qName))
  })
)

export default enqueuePrint